// extracted by mini-css-extract-plugin
module.exports = {"root":"Main_root__2Gtgh","content":"Main_content__1DARt"};